import { ReturnPage } from "@tenant/flights";
import type { PackageFlightReturnPageProps } from "./types";

export const PackageFlightReturnPage = (
  props: PackageFlightReturnPageProps
) => {
  return <ReturnPage {...props} />;
};
